<template>
  <b-card>
    <div slot="header">
      <b>Lista de contratos</b>
    </div>

    <b-col md="12">
      <b-dropdown
        id="dropdown-form"
        text="Exibir / ocultar colunas"
        ref="dropdown"
        class="my-2"
        variant="outline-info"
      >
        <!-- <b-form-checkbox v-for="(field,i) in fields" @click="toggleColuna($event, i)" >{{field.label}}</b-form-checkbox> -->
        <!-- <b-dropdown-item-button v-for="(field,i) in fields" @click="toggleColuna($event, i)"> -->
        <!-- <b-form-checkbox ref="chk">{{field.label}}</b-form-checkbox> -->
        <template v-for="(field,i) in fields">
          <b-dropdown-item-button @click="toggleColuna($event, i)">
            <label><input type="checkbox" ref="chk" />{{field.label}}</label>
          </b-dropdown-item-button>
        </template>
        <!-- </b-dropdown-item-button> -->
      </b-dropdown>
    </b-col>

    <b-row>
      <b-col xs="12" md="12" class="mx-auto">
        <b-col xs="12">
          <div>
            <b-table
              id="filaContratos"
              :items="resultado"
              :fields="fields"
              striped
              responsive="sm"
              stacked="sm"
            >
              <template slot="situacao" slot-scope="row">
                <template v-if="row.item.situacao === 'AGUARDANDO'">
                  <b-badge pill variant="info">
                    <i class="fa fa-clock-o" aria-hidden="true"></i> Aguardando processamento
                  </b-badge>
                </template>
                <template v-if="row.item.situacao === 'AGUARDANDO_SINC_DETRAN'">
                  <b-badge pill variant="danger">
                    <i class="fa fa-exclamation-circle" aria-hidden="true"></i> Erro de comunicação com DETRAN
                  </b-badge>
                </template>
                <template v-if="row.item.situacao === 'ERRO_SINC_NAO_NEGOCIAL'">
                  <b-badge pill variant="danger">
                    <i class="fa fa-exclamation-circle" aria-hidden="true"></i> Erro de comunicação
                  </b-badge>
                </template>
                <template v-if="row.item.situacao === 'ERRO_SINC_NEGOCIAL'">
                  <b-badge pill variant="warning">
                    <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Dados incorretos
                  </b-badge>
                </template>
                <template v-if="row.item.situacao === 'SUCESSO'">
                  <b-badge pill variant="success">
                    <i class="fa fa-check" aria-hidden="true"></i> Concluído
                  </b-badge>
                </template>
              </template>

              <template slot="mostrar_detalhes" slot-scope="row">
                <b-link @click="row.toggleDetails" title="Mostrar detalhes" class="action">
                  <i :class="row.detailsShowing ? 'fa fa-angle-up' : 'fa fa-angle-down'"></i>
                </b-link>
                <template v-if="row.item.situacao === 'ERRO_SINC_NEGOCIAL'">
                  <b-link to="/contrato" title="Alterar" class="action">
                    <i class="fa fa-pencil"></i>
                  </b-link>
                </template>
                <b-link to="/contrato/view" title="Visualizar" class="action">
                  <i class="fa fa-eye"></i>
                </b-link>
              </template>

              <template slot="row-details" slot-scope="row">
                <b-row class="mb-2">
                  <b-col sm="3" class="text-sm-right">
                    <b>Descrição:</b>
                  </b-col>
                  <b-col>{{ row.item.descricao }}</b-col>
                </b-row>
                <b-button size="sm" @click="row.toggleDetails">Tentar novamente</b-button>
              </template>
            </b-table>
          </div>
        </b-col>
      </b-col>
    </b-row>
    <b-row class="justify-content-center">
      <b-pagination v-model="currentPage" :total-rows="rows" size="sm"></b-pagination>
    </b-row>
  </b-card>
</template>

<script>
export default {
  props: {
    listaSincronismo: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      fields: [
        {
          key: "data_contrato",
          label: "Data do Contrato",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "num_contrato",
          label: "Número do Contrato",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "nome",
          label: "Nome",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "operador",
          label: "Operador",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "mostrar_detalhes",
          label: "Ações",
          sortable: false
        }
      ],
      perPage: 5,
      currentPage: 1,
      rows: 150,
      resultado: [
        {
          isActive: true,
          data_contrato: "05/01/2019",
          descricao: "Operação concluída com êxito.",
          chassi: "1122334455",
          nome: "Leonardo da Vinci",
          operador: "Carolina Oliveira",
          num_contrato: "10001"
        },
        {
          isActive: false,
          data_contrato: "04/02/2019",
          num_contrato: "10002",
          descricao: "Erro de comunicação.",
          chassi: "2222334455",
          nome: "Machado de Assis",
          operador: "Rubens Meneghel"
        },
        {
          isActive: false,
          data_contrato: "27/02/2019",
          num_contrato: "10003",
          descricao: "Erro de comunicação.",
          chassi: "3322334455",
          nome: "Ayrton Senna da Silva",
          operador: "Andressa Fonseca"
        },
        {
          isActive: true,
          data_contrato: "04/03/2019",
          num_contrato: "10004",
          descricao: "Dados incorretos.",
          chassi: "3322334455",
          nome: "Albert Einsten",
          operador: "Carolina Oliveira"
        },
        {
          isActive: true,
          data_contrato: "14/03/2019",
          num_contrato: "10005",
          descricao: "Dados incorretos.",
          situacao: "EM_ANALISE",
          chassi: "3322334455",
          nome: "Ana Machado",
          operador: "Carolina Oliveira"
        }
      ]
    };
  },
  methods: {
    toggleColuna(event, i) {
      //this.fields[i].tdClass = (event.target.checked ? "" : "td-hidden");
      this.fields[i].tdClass = (this.$refs.chk[i].checked ? "" : "td-hidden");
    }
  }
};
</script>

<style>
.td-hidden {
  display: none;
}
</style>



